import React, { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import { Form } from "../../components/form";
import { OnBoardingPageForm } from "./onboardingpageform";

export const OnBoardingPageBody = (props) => {
  const { updateDirtyState,plan, ...other } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const pageState = useSelector((state) => state.onBoardingPage);

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Fragment>
         
            <OnBoardingPageForm updateDirtyState={updateDirtyState} plan={plan} />
        </Fragment>
      )}
      <style>{``}</style>
    </Fragment>
  );
};
